import React from 'react';
import gplaylogin from 'images/icons/gplaylogin.svg';

// eslint-disable-next-line jsx-a11y/alt-text
const GooglePlayIcon = () => <img src={gplaylogin} />;

export default GooglePlayIcon;
